import type { FC, ReactElement } from "react";

import clsx from "clsx";

import { ActionButtonBanner, type IActionButtonBanner } from "../common/ActionButtonBanner";
import ImageBanner, { type IImageBanner } from "../common/ImageBanner";
import InvalidDiscountImage from "./InvalidDiscountImage";

import * as css from "./DiscountBanner.module.css";

export interface IDiscountBanner {
    id: string;
    discountImage: IImageBanner;
    invalidDiscountImage?: IImageBanner;
    likeAndShare?: IActionButtonBanner;
}

const DiscountBanner: FC<IDiscountBanner> = (props) => {
    let image: ReactElement = null;

    const { likeAndShare } = props;

    if (props.invalidDiscountImage) {
        image = <InvalidDiscountImage {...props.invalidDiscountImage} />;
        if (likeAndShare && likeAndShare.saveLink) {
            likeAndShare.saveLink = true;
            likeAndShare.saveLinkType = "discounts";
            likeAndShare.share.disabled = true;
        }
    } else if (props.discountImage) {
        image = <ImageBanner {...props.discountImage} id={props.id} />;
    }

    return (
        <div className={clsx(css.discountBannerComponent, props.invalidDiscountImage && css.disabled)}>
            {image}
            {likeAndShare && <ActionButtonBanner {...likeAndShare} />}
        </div>
    );
};

export default DiscountBanner;
